import {
    useEffect
} from "react";
import {useParams} from "react-router-dom";
import CurrentClientContext from "../../providers/CurrentClientProvider";
import KpiTable from "../../components/client/KpiTable.component";

function ClientKPI(props) {
    const currentClient = CurrentClientContext.useClient()
    const client = currentClient.client
    let { client_code, clientId } = useParams()

    useEffect(() => {
		document.title = 'Retail ORBIT: Client KPI'
	}, [])

    return <>
        <div style={{marginTop: 15}}>
            <KpiTable clientId={client?.Id} />
        </div>
    </>
}

export default ClientKPI